export default __webpack_public_path__ + "static/media/82582125668d5dc8.56eadb9400c3ebdef1a8d6de86ad5018.svg";